export enum AssetProjectPref {
	ENABLED = 'review.enabled',
}
